module.exports = __webpack_public_path__ + "media/images/article/polygon_04-933d5b4769b8b58e9ddc601ab70b2a05.png";